/**
 * Texts for Training page
 */
export const trainingPageText = {
    title: 'Školení – CamAPS FX',
    titleMeta: 'Uživatelům aplikace CamAPS FX nabízíme zdarma školení',
    descriptionMeta: 'Cambridge Diabetes Education Programme pořádá bezplatné certifikované online školení pro osoby s diabetem 1. typu, rodiče a opatrovatele a školní a zdravotnické pracovníky.',
    keywords: 'školení camps, školení camps fx, ',
    localeMeta: 'cs_cz',
    mainHeader: 'Zdravotnické školení',
    mainSubHeader: 'Podporujte osoby používající CamAPS FX prostřednictvím školení vedeného odborníky.',
    gettingStartedHeader: 'Začínáme',
    step1Title: '<strong>Krok 1:</strong><br/>Stáhněte si aplikaci',
    step2Title: '<strong>Krok 2:</strong><br/>Vytvořte účet',
    step3Title: '<strong>Krok 3:</strong><br/>Začněte důležité školení v aplikaci',
    step4Title: '<strong>Krok 4:</strong><br/>Spárujte se svou zvolenou pumpou a CGM (se souhlasem vašeho zdravotnického týmu) nebo prozkoumejte aplikaci ve <strong>virtuálním režimu</strong>',
    videoSrc: '/video/In-app training loop_1.mp4',
    certifiedTrainingTitle: 'Certifikované školení',
    trainingHeader: 'Certifikované školení',
    trainingHeader_2: 'Pro zdravotnické pracovníky',
    trainingHeader_3: 'Školení uživatelů',
    trainingHeaderText: 'BEZPLATNÉ online školení CamAPS FX na platformě Cambridge Diabetes Education Programme (CDEP).',
    websiteLink: 'https://www.camdiabtraining.com/account-sign-in.html',
    websiteLinkHeading: 'Školení CDEP',
    getTrained: 'Přihlásit se na školení',
    trainingHeaderIat: 'Školení CamAPS FX',
    trainingHeaderTextIat: 'Dokončete základní školení v aplikaci před použitím aplikace CamAPS FX.',
    trainingSubHeaderOneIat: 'Začínáme',
    trainingSubTextOneIat: 'Stáhněte si aplikaci CamAPS FX. <br>Vytvořte si účet a začněte školení.',
    trainingSubHeaderTwoIat: 'Potřebujete pomoc s instalací aplikace?',
    trainingParaTwoStartIat: 'Navštivte naši',
    trainingParaTwoEndIat: 'sekci s pokyny.',
    websiteLinkHeadingSupportIat: 'Podpora',
    trainingSubHeaderThreeIat: 'Další zdroje',
    animationsYpsoPumpText: 'Animace',
    animationsAndText: 'a',
    animationsDanaText: 'Animace (pumpa Dana)',
    animationsFurtherText: 'Naučte se díky krok za krokem vizuálním ukázkám.',
    webinarsText: 'Webináře',
    webinarsFurtherText: 'Sledujte odborně vedené sezení o používání aplikace.',
    websiteAnimationsYpsoPumpLink: 'https://www.camdiabtraining.com/view/27/mylife-YpsoPump-users.htm',
    websiteAnimationsDanaLink: 'https://www.camdiabtraining.com/view/25/Dana-insulin-pump-users.htm',
    websiteWebinarsLink: 'https://www.camdiabtraining.com/view/20/Webinars.htm',
};
